import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export default () => {
    const inertiaProps = usePage<IRhizomPageProps>();

    const hasAlertsAccess = computed(() => {
        // Admin users have access to all features regardless of subscription
        if (inertiaProps.props.isAdmin || inertiaProps.props.hasGodMode) {
            return true;
        }
        // Team must have scale plan or be trialing to access alerts
        return inertiaProps.props.hasScalePlan || inertiaProps.props.isTrialing;
    });

    return {
        hasAlertsAccess,
    };
};
